import script from "./ImportPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImportPreview.vue?vue&type=script&setup=true&lang=ts"

import "./ImportPreview.vue?vue&type=style&index=0&id=465c50c2&lang=css&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Web.API\\client-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-465c50c2"]])

export default __exports__